const STORAGE_KEY = 'accounting_payroll_doc_settings_v1';

export type PayrollDocSettings = {
  payable_account_code: string;
  expense_account_code: string;
};

const DEFAULTS: PayrollDocSettings = {
  payable_account_code: '',
  expense_account_code: '',
};

export function readPayrollDocSettings(): PayrollDocSettings {
  if (typeof window === 'undefined') return { ...DEFAULTS };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<PayrollDocSettings>;
    return {
      payable_account_code: String(parsed.payable_account_code ?? '').trim(),
      expense_account_code: String(parsed.expense_account_code ?? '').trim(),
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePayrollDocSettings(settings: PayrollDocSettings): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export function isPayrollDocSettingsValid(settings: PayrollDocSettings): boolean {
  return Boolean(settings.payable_account_code.trim() && settings.expense_account_code.trim());
}
